import React from 'react';
import { ListingImage } from '../elements-image/listing-image';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const ProjectThumb = ({
  id,
  coverImageId,
  ratio,
  widths,
  alt,
  hourlyPrice,
  currency,
  infoBox = null,
  noHover
}) => {
  const InfoBox = infoBox;

  return (
    <div className={`thumbnail ${noHover ? 'no-hover' : ''}`}>
      <div
        id={ id }
        className="hover-wrapper"
      />
      <div className="img-container">
        <ListingImage
          imgId={ coverImageId }
          ratio={ ratio }
          widths={ widths }
          defaultWidth={512}
          defaultHeight={303}
          dpr={1.0}
          alt={ alt }
          sizes="50vw"
        />
        { hourlyPrice ?
          <div className="favorite-block price">
            <span className="price-text-left">
              <FormattedNumber
                value={hourlyPrice}
                currency={currency}
                style="currency"
                minimumFractionDigits={0 === hourlyPrice % 1 ? 0 : 2}
                maximumFractionDigits={0 === hourlyPrice % 1 ? 0 : 2}
              />
            </span>
            <span className="price-text-right">
              <div>
                <FormattedMessage
                  id="boards.project_thumb.per"
                  defaultMessage="per"
                />
              </div>
              <div>
                <FormattedMessage
                  id="boards.project_thumb.hour"
                  defaultMessage="hour"
                />
              </div>
            </span>
          </div>
          : null
        }
      </div>
      { infoBox && (
        <div className="info-container">
          <InfoBox />
        </div>
      )}
    </div>
  );
};

export default ProjectThumb;
